import {
  GET_CHANNELS_SUCCEEDED,
  GET_CHANNELS_ERROR,
  READ_STATUS_UPDATED,
  GET_CHAT_PRESETS_ERROR,
  GET_CHAT_PRESETS_SUCCEEDED,
  CHECK_KICKSTART_SUCCEEDED,
  CHECK_KICKSTART_ERROR,
  GET_MESSAGES_FIRST_PAGE_SUCCEEDED,
  GET_MESSAGES_FIRST_PAGE_ERROR,
  GET_MESSAGES_PREV_PAGE_SUCCEEDED,
  GET_MESSAGES_PREV_PAGE_ERROR,
  MESSAGE_ADDED,
  CLEAR_ACTIVE_CHANNEL_STATE,
  CHANNEL_ADDED,
  CHANNEL_REMOVED,
  START_LOADING_MESSAGES
} from './types';

const INITIAL_STATE = {
  channels: null,
  chatPresets: null,
  unreadChannels: null,
  isKickstartCompleted: false,
  currentPage: null,
  messages: null,
  currentChannelSid: null,
  isMessagesLoading: false
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CLEAR_ACTIVE_CHANNEL_STATE:
      return {
        ...state,
        isKickstartCompleted: null,
        currentPage: null,
        messages: null,
        currentChannelSid: null,
        isMessagesLoading: false
      };
    case GET_CHANNELS_SUCCEEDED:
      var unreadChannels = new Set();
      // remove old listeners
      if (state.channels)
        for (let i = 0; i < state.channels.length; i++) {
          state.channels[i].removeAllListeners();
        }
      // set unread channels list
      for (let i = 0; i < action.payload.length; i++) {
        let chan = action.payload[i];
        if (
          chan.lastMessage &&
          chan.lastMessageObj.index > chan.lastConsumedMessageIndex
        )
          unreadChannels.add(chan.sid);
      }

      return {
        ...state,
        channels: action.payload,
        unreadChannels
      };
    case GET_CHANNELS_ERROR:
      return { ...state, error: action.payload };
    case MESSAGE_ADDED:
      var msg = action.payload;
      // update read status if the new msg belongs to the active channel
      // else mark the channel as unread
      if (msg.channel.sid === state.currentChannelSid)
        msg.channel.updateLastConsumedMessageIndex(msg.index);
      else state.unreadChannels.add(msg.channel.sid);

      return {
        ...state,
        unreadChannels: new Set(state.unreadChannels),
        messages:
          msg.channel.sid === state.currentChannelSid
            ? [...state.messages, msg]
            : state.messages,
        channels: state.channels.map(channel =>
          channel.sid === msg.channel.sid ? msg.channel : channel
        )
      };
    case READ_STATUS_UPDATED:
      const chan = action.payload;
      if (
        state.unreadChannels &&
        chan.lastConsumedMessageIndex >= chan.lastMessage.index
      )
        state.unreadChannels.delete(chan.sid);

      return {
        ...state,
        unreadChannels: new Set(state.unreadChannels),
        channels:
          state.channels &&
          state.channels.map(channel => {
            if (channel.sid === chan.sid) {
              chan.lastMessageObj = channel.lastMessageObj;
              return chan;
            }
            return channel;
          })
      };
    case CHANNEL_ADDED:
      return {
        ...state,
        channels: state.channels && [...state.channels, action.payload]
      };
    case CHANNEL_REMOVED:
      state.unreadChannels && state.unreadChannels.delete(action.payload.sid);
      return {
        ...state,
        unreadChannels: new Set(state.unreadChannels),
        channels:
          state.channels &&
          state.channels.filter(channel => channel.sid !== action.payload.sid)
      };
    case GET_CHAT_PRESETS_SUCCEEDED:
      return { ...state, chatPresets: action.payload };
    case GET_CHAT_PRESETS_ERROR:
      return { ...state, error: action.payload };
    case CHECK_KICKSTART_SUCCEEDED:
      return { ...state, isKickstartCompleted: action.payload };
    case CHECK_KICKSTART_ERROR:
      return { ...state, error: action.payload };
    case GET_MESSAGES_FIRST_PAGE_SUCCEEDED:
      return {
        ...state,
        currentPage: action.payload.page,
        messages: action.payload.page.items,
        currentChannelSid: action.payload.currentChannelSid,
        isMessagesLoading: false
      };
    case START_LOADING_MESSAGES:
      return {
        ...state,
        isMessagesLoading: true
      };
    case GET_MESSAGES_FIRST_PAGE_ERROR:
      return { ...state, error: action.payload };
    case GET_MESSAGES_PREV_PAGE_SUCCEEDED:
      return {
        ...state,
        currentPage: action.payload,
        messages: [...action.payload.items, ...state.messages]
      };
    case GET_MESSAGES_PREV_PAGE_ERROR:
      return { ...state, error: action.payload };
    default:
      return state;
  }
}
